// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__27603","actionsCol":"EnrolledClinics_actionsCol__lQYNY"};